import React from 'react'
import { useLocation } from 'react-router-dom';
import HelpBox from './HelpBox';
import { HOME_URL, DAY_TO_UPDATE_YEAR } from '../../constants/constants';
import '../../../src/assets/scss/common/_footer.scss';
import { connect } from 'react-redux';
import { updateYearBeforeNewYear } from '../../helper';
const Footer = (props) => {
    const location = useLocation();
    let cName = props.hasOwnProperty('className') ? (props.className != '' ? ' ' + props.className : '') : '';
    const url = (location.pathname).includes("/allinone") || (location.pathname).includes("/rearrange") ;
    const urlMembership = (location.pathname).includes("/membership/");
    const yearToDisplay = updateYearBeforeNewYear(DAY_TO_UPDATE_YEAR);

    return (<>
        <div className={`no-print footer-container${url ? ' allinone-editor-footer' : ""}` + cName}>
            <footer className="footer">
                {urlMembership ? (
                    <p>&copy;  {yearToDisplay} Resume.org. All rights reserved. 450 Alaskan Way South, Suite 200, Seattle, WA 98104 | <a href={`${HOME_URL}/terms-and-conditions/`} target="_blank"> Terms of Service </a> | <a href={`${HOME_URL}/privacy-policy/`}  target="_blank"> Privacy Policy </a> | <a href={`${HOME_URL}/about-us/#where-to-find-us`}  target="_blank"> Contact Us </a></p>
                    ) :(
                    <p> &copy; {yearToDisplay} Resume.org. All rights reserved. <a href={`${HOME_URL}/about-us/#where-to-find-us`} target="_blank"> Contact Us.</a></p>
                )}
            </footer>
        </div>
        <HelpBox {...props} />
    </>
    );
}

export default connect(state => state)(Footer);
